import { ActionTypes } from '../constants/AppConstants';
import BaseStore from './BaseStore';

class LayoutStore extends BaseStore {

    getActionHandlers() {
        return {
            [ActionTypes.IN_APP_SESSION_STARTED]: this.handleEmbeddedLayout,
            [ActionTypes.SEARCH_WIDGET_LOADED]: this.handleEmbeddedLayout,
            [ActionTypes.LAYOUT_SET_EMBEDDED]: this.handleSetEmbedded,
        };
    }

    isEmbeddedLayout() {
        return Boolean(this.state.get('isEmbedded'));
    }

    handleEmbeddedLayout() {
        this.setState(this.state.set('isEmbedded', true));
    }

    handleSetEmbedded({ isEmbedded }) {
        this.setState(this.state.set('isEmbedded', isEmbedded));
    }
}

const storeInstance = new LayoutStore({ storageKey: 'layout' });

export default storeInstance;



// WEBPACK FOOTER //
// ./src/stores/LayoutStore.js